import { FaArrowRight } from "react-icons/fa6";
import { DecodeHtml } from "../../utils/decodeHtml"
import useFetch from "../../utils/useFetch"
import { motion } from 'framer-motion';
import ModelButton from "../modelBtn/modelButton";
import { useState } from "react";
import { PropTypes } from 'prop-types';

const ShowProgramData = ({ url }) => {

    const data = useFetch(url)
    const program = data?.properties

    const title = program?.title
    const content = DecodeHtml({ html: program?.richTextContent?.markup })
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);


    return (
        <div>
            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.9 }}

                onClick={() => (modalOpen ? closed() : open())}
            >
                <span >{title}</span>
            </motion.button>
            <ModelButton modalOpen={modalOpen} close={closed}>
                <div className="flex flex-col gap-5 w-full text-  p-4 max-h-[80vh] max-w-[80vw]  overflow-y-auto scroll-bar">
                    <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{title}</h1>
                    <div className='grid gap-14 text-zinc-500 font-normal'>
                        {
                            content
                        }

                    </div>
                </div >
            </ModelButton>
        </div>
    )
}
ShowProgramData.propTypes = {
    url: PropTypes.any
}
export default ShowProgramData